var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "circle-container",
      on: {
        mouseover: _vm.showTooltip,
        mouseleave: _vm.hideTooltip,
        click: _vm.toggleTooltip
      }
    },
    [
      _c("div", { staticClass: "circle" }, [_vm._v("?")]),
      _vm._v(" "),
      _vm.isTooltipVisible
        ? _c("div", { staticClass: "tooltip" }, [_vm._v(_vm._s(_vm.text))])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bfb4c470", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfb4c470","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/kirc/components/CircleTooltip.vue
// module id = null
// module chunks = 